import * as React from "react";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import { InstrumentSelections } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { PensionTransfer } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/PensionTransfer";

interface IDocumentProps extends IProcessComponentProps {}

interface IDocumentState {}

export class Document extends ProcessComponent<IDocumentProps, IDocumentState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return (
            <>
                <h4 className="h4 mr-10">Documents</h4>
                {this.renderDocuments()}
                <br />
            </>
        );
    }

    private renderDocuments() {
        const customerid = getQueryParameters()["customerid"];
        const claccountid = getQueryParameters()["claccountid"];
        const instructionId = getQueryParameters()["id"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const chargesInformationQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargesInformation,
            processTypeEnum.Quote
        );
        const chargesSummaryQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargeSummary,
            processTypeEnum.Quote
        );
        const termsAndConditionsQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.TermsAndCondition,
            processTypeEnum.Quote
        );
        return (
            <>
                {this.displayChargesInformation() && (
                    <>
                        <div className="mb-24">
                            <DownloadButton
                                title="Charges Information"
                                request={chargesInformationQuery}
                                selectedAccount={headAccountHierarchyId}
                            ></DownloadButton>
                        </div>
                    </>
                )}
                <div className="mb-24">
                    <DownloadButton
                        title="Charges Summary"
                        request={chargesSummaryQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
            </>
        );
    }

    private displayChargesInformation(): boolean {
        const { data } = this.props;
        return (
            this.hasAllocationExceptGBPCash(data?.GiaQuote?.InstrumentSelections) ||
            this.hasAllocationExceptGBPCash(data?.ISAQuote?.InstrumentSelections) ||
            this.hasAllocationExceptGBPCash(data?.PensionQuote?.PreRetirementInstrumentSelections) ||
            this.hasAllocationExceptGBPCash(data?.PensionQuote?.PostRetirementInstrumentSelections) ||
            this.hasRetirementAllocationExceptGBPCash(data?.PensionQuote?.PensionTransfers)
        );
    }

    private hasAllocationExceptGBPCash(instrumentSelections: InstrumentSelections): boolean {
        return instrumentSelections?.Instruments?.some((x) => x.Instrument.Name != "GBP Cash");
    }

    private hasRetirementAllocationExceptGBPCash(pensionTransfers: Array<PensionTransfer>): boolean {
        return pensionTransfers?.some((y) => y.Instruments?.some((x) => x.Investment.DisplayName != "GBP Cash"));
    }
}
